<div class="d-flex flex-column gap-3">
  <app-project-details-layout
    [project]="project()"
    [files]="files()"
    [contactUser]="contactUser()"
    [isLoading]="isLoading()"
  />
</div>
